var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _c(
      "div",
      { staticClass: "common-header" },
      [
        _c("common-header", {
          attrs: {
            headerList: [
              { label: "系统管理", url: "" },
              { label: "用户打标规则", url: "/system/userRule" },
              { label: "规则信息", url: "" }
            ]
          }
        })
      ],
      1
    ),
    _c("div", { staticClass: "editRule" }, [
      _c(
        "div",
        { staticClass: "editRule-top", class: { watchHeight: !_vm.isEdit } },
        [
          _c("p", { staticClass: "editRule-top-title" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.isAdd ? "新增规则" : _vm.isEdit ? "编辑规则" : "查看规则"
                )
            )
          ]),
          _vm.isEdit || _vm.isAdd
            ? _c(
                "el-form",
                {
                  ref: "formSubmit",
                  attrs: {
                    inline: true,
                    rules: _vm.formRules,
                    model: _vm.formInline,
                    "label-position": "top"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "editRule-top-item" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "editRule-top-item-title",
                          attrs: { label: "筛选规则名称", prop: "ruleName" }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入筛选规则名称" },
                            model: {
                              value: _vm.formInline.ruleName,
                              callback: function($$v) {
                                _vm.$set(_vm.formInline, "ruleName", $$v)
                              },
                              expression: "formInline.ruleName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "editRule-top-item-contant",
                          attrs: { label: "规则服务模块", prop: "systemId" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择规则服务模块",
                                clearable: ""
                              },
                              model: {
                                value: _vm.formInline.systemId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formInline, "systemId", $$v)
                                },
                                expression: "formInline.systemId"
                              }
                            },
                            _vm._l(_vm.systemList, function(option, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: option.systemName,
                                  value: option.systemId
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "editRule-top-item-contant",
                          attrs: { label: "规则状态", prop: "ruleStatus" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: "",
                                placeholder: "请选择规则状态"
                              },
                              model: {
                                value: _vm.formInline.ruleStatus,
                                callback: function($$v) {
                                  _vm.$set(_vm.formInline, "ruleStatus", $$v)
                                },
                                expression: "formInline.ruleStatus"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "有效", value: "ACTIVE" }
                              }),
                              _c("el-option", {
                                attrs: { label: "失效", value: "INACTIVE" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "editRule-top-item-description",
                              staticStyle: { "margin-right": "0" },
                              attrs: {
                                label: "筛选规则描述",
                                prop: "description"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入筛选规则描述",
                                  maxlength: "500",
                                  "show-word-limit": ""
                                },
                                model: {
                                  value: _vm.formInline.description,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formInline, "description", $$v)
                                  },
                                  expression: "formInline.description"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          !_vm.isEdit && !_vm.isAdd
            ? _c("div", { staticClass: "editRule-watch" }, [
                _c("div", { staticClass: "editRule-watch-top" }, [
                  _c(
                    "p",
                    {
                      staticClass: "editRule-watch-content",
                      staticStyle: { "margin-right": "226px" }
                    },
                    [
                      _vm._v("筛选规则名称："),
                      _c("span", [_vm._v(_vm._s(_vm.formInline.ruleName))])
                    ]
                  ),
                  _c(
                    "p",
                    {
                      staticClass: "editRule-watch-content",
                      staticStyle: { "margin-right": "226px" }
                    },
                    [
                      _vm._v("规则服务模块："),
                      _c("span", [_vm._v(_vm._s(_vm.formInline.systemName))])
                    ]
                  ),
                  _c("p", { staticClass: "editRule-watch-content" }, [
                    _vm._v("规则状态："),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.formInline.ruleStatus == "ACTIVE"
                            ? "有效"
                            : "失效"
                        )
                      )
                    ])
                  ])
                ]),
                _c("div", { staticClass: "editRule-watch-bot" }, [
                  _vm._v("筛选规则描述："),
                  _c("span", [_vm._v(_vm._s(_vm.formInline.description))])
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "editRule-bot" },
        [
          _vm.isEdit || _vm.isAdd
            ? _c(
                "div",
                _vm._l(_vm.ruleList, function(element, i) {
                  return _c(
                    "div",
                    { key: i },
                    [
                      _c("rule-item", {
                        attrs: { jobList: _vm.jobList, item: element, num: i },
                        on: {
                          "update:item": function($event) {
                            element = $event
                          },
                          delRuleItem: _vm.delRuleItem
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._l(_vm.ruleList, function(ruleItem, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "editRule-bot-item" },
                  [
                    _c("div", { staticClass: "editRule-bot-item-top" }, [
                      _c("div", { staticClass: "editRule-bot-item-top-left" }, [
                        _vm._v(" 规则" + _vm._s(index + 1) + " ")
                      ])
                    ]),
                    _c("div", { staticClass: "editRule-bot-item-table" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "editRule-bot-item-table-top editRule-bot-item-table-row"
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "editRule-bot-item-table-top-title"
                            },
                            [_vm._v("规则条件（多选）:")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: ruleItem.jobSelected,
                                callback: function($$v) {
                                  _vm.$set(ruleItem, "jobSelected", $$v)
                                },
                                expression: "ruleItem.jobSelected"
                              }
                            },
                            [_vm._v("职位编码")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: ruleItem.orgSelected,
                                callback: function($$v) {
                                  _vm.$set(ruleItem, "orgSelected", $$v)
                                },
                                expression: "ruleItem.orgSelected"
                              }
                            },
                            [_vm._v("组织机构")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: ruleItem.businessLineSelected,
                                callback: function($$v) {
                                  _vm.$set(
                                    ruleItem,
                                    "businessLineSelected",
                                    $$v
                                  )
                                },
                                expression: "ruleItem.businessLineSelected"
                              }
                            },
                            [_vm._v("业务条线")]
                          )
                        ],
                        1
                      ),
                      ruleItem.jobSelected
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "editRule-bot-item-table-mid editRule-bot-item-table-row "
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "editRule-bot-item-table-mid-title"
                                },
                                [_vm._v("职位编码")]
                              ),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    width: "120px",
                                    "margin-right": "130px"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      ruleItem.userLabelConditionJob.operator ==
                                        "INCLUDE"
                                        ? "属于"
                                        : "不属于"
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    width: "120px",
                                    flex: "1",
                                    "margin-right": "130px",
                                    height: "22px",
                                    "font-size": "14px",
                                    "font-family":
                                      "PingFangSC, PingFangSC-Regular",
                                    "font-weight": "400",
                                    "text-align": "left",
                                    color: "#333333",
                                    "line-height": "22px",
                                    "white-space": "nowrap",
                                    "text-overflow": "ellipsis",
                                    overflow: "hidden"
                                  },
                                  attrs: {
                                    title: ruleItem.userLabelConditionJob.value
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(ruleItem.userLabelConditionJob.value)
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      ruleItem.orgSelected
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "editRule-bot-item-table-mid editRule-bot-item-table-row"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "editRule-bot-item-table-mid-title"
                                },
                                [_vm._v("组织机构")]
                              ),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    width: "120px",
                                    "margin-right": "130px"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      ruleItem.userLabelConditionOrg.operator ==
                                        "INCLUDE"
                                        ? "属于"
                                        : "不属于"
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    width: "120px",
                                    "margin-right": "130px",
                                    flex: "1",
                                    height: "22px",
                                    "font-size": "14px",
                                    "font-family":
                                      "PingFangSC, PingFangSC-Regular",
                                    "font-weight": "400",
                                    "text-align": "left",
                                    color: "#333333",
                                    overflow: "hidden",
                                    "text-overflow": "ellipsis",
                                    "white-space": "nowrap",
                                    "line-height": "22px"
                                  },
                                  attrs: {
                                    title: ruleItem.userLabelConditionOrg.value
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(ruleItem.userLabelConditionOrg.value)
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      ruleItem.businessLineSelected
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "editRule-bot-item-table-mid editRule-bot-item-table-row"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "editRule-bot-item-table-mid-title"
                                },
                                [_vm._v("业务条线")]
                              ),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    width: "120px",
                                    "margin-right": "130px"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      ruleItem.userLabelConditionBusiness
                                        .operator == "INCLUDE"
                                        ? "属于"
                                        : "不属于"
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    width: "120px",
                                    "margin-right": "130px",
                                    height: "22px",
                                    flex: "1",
                                    "font-size": "14px",
                                    "font-family":
                                      "PingFangSC, PingFangSC-Regular",
                                    "font-weight": "400",
                                    "text-align": "left",
                                    "white-space": "nowrap",
                                    overflow: "hidden",
                                    "text-overflow": "ellipsis",
                                    color: "#333333",
                                    "line-height": "22px"
                                  },
                                  attrs: {
                                    title:
                                      ruleItem.userLabelConditionBusiness.value
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      ruleItem.userLabelConditionBusiness.value
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  ]
                )
              }),
          _c("div"),
          _vm.isEdit || _vm.isAdd
            ? _c("p", { staticClass: "editRule-bot-addRule" }, [
                _vm._v("如果需要添加“或”的关系，请点击"),
                _c(
                  "span",
                  { staticClass: "colorD43 point", on: { click: _vm.addRule } },
                  [_vm._v("添加规则组")]
                )
              ])
            : _vm._e()
        ],
        2
      )
    ]),
    _c("div", { staticClass: "footer-page" }, [
      _c(
        "div",
        { staticClass: "role-footer-left" },
        [
          _c(
            "el-button",
            {
              staticClass: "btn btn-del",
              staticStyle: { "margin-left": "10px" },
              attrs: { value: "返回" },
              on: { click: _vm.reBack }
            },
            [_vm._v("返回")]
          ),
          _c(
            "el-button",
            {
              staticClass: "btn btn-del",
              staticStyle: { "margin-left": "20px", width: "auto !important" },
              attrs: { disabled: _vm.ruleList.length == 0 },
              on: { click: _vm.preview }
            },
            [_vm._v("预览成员")]
          ),
          _c(
            "el-popconfirm",
            {
              attrs: { title: "确定删除此规则吗？" },
              on: {
                onConfirm: function($event) {
                  return _vm.confirmdel(_vm.scope, true)
                },
                onCancel: function($event) {
                  return _vm.confirmdel(_vm.scope, false)
                }
              }
            },
            [
              _vm.delRule && _vm.isEdit
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn btn-del",
                      staticStyle: {
                        "margin-left": "20px",
                        width: "auto !important"
                      },
                      attrs: { slot: "reference" },
                      slot: "reference"
                    },
                    [_vm._v("删除本规则筛选")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm.isEdit || _vm.isAdd
            ? _c(
                "el-button",
                {
                  staticClass: "btn btn-red",
                  staticStyle: { "margin-left": "20px", height: "32px" },
                  attrs: { value: "提交", disabled: _vm.ruleList.length == 0 },
                  on: { click: _vm.submit }
                },
                [_vm._v("提交")]
              )
            : _vm._e(),
          _vm.delRule && !_vm.isEdit
            ? _c(
                "el-button",
                {
                  staticClass: "btn btn-red",
                  staticStyle: {
                    "margin-left": "20px",
                    height: "32px",
                    width: "auto !important"
                  },
                  attrs: { value: "编辑规则" },
                  on: { click: _vm.editChoose }
                },
                [_vm._v("编辑规则")]
              )
            : _vm._e()
        ],
        1
      ),
      _c("div", { staticClass: "role-footer-right" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }